/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SetTagValue$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected tag
 */
  tagUid: string;

/**
 * The value to set, must comply to the tag's datatype
 */
  value: string;
}

export function setTagValue(http: HttpClient, rootUrl: string, params: SetTagValue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setTagValue.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('tagUid', params.tagUid, {});
    rb.query('value', params.value, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setTagValue.PATH = '/stations/{uid}/drive/{tagUid}';
